import tripActions from '../actions/tripActions';
import createReducer from '../utils/createReducer';
import TripRecord from '../records/tripRecord';

const initialState = new TripRecord();

const actionHandlers = {
    [tripActions.SET_BOOKING_FLOW](state, {payload}) {
        return state.merge({isBookingFlow: payload.isBookingFlow});
    },
    [tripActions.UPDATE_TRIP_DETAILS](state, {payload = {}}) {
        const {fieldsChanged} = payload;

        return state.merge(fieldsChanged);
    }
};

export default createReducer(actionHandlers, initialState);
